<template>
  <div>1</div>
</template>

<script>
export default {
  name: "ProductAnalysisSoilConsulting"
}
</script>

<style scoped>

</style>